/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { DateRange } from '@jira/servicedesk__virtual-agent-conversations/src/DateRange.types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import VirtualAgentBrowseConversationsQuery from './__generated__/VirtualAgentBrowseConversationsQuery$parameters';
import type { VirtualAgentBrowseConversationsQuery as QueryType } from './__generated__/VirtualAgentBrowseConversationsQuery.graphql';

const DEFAULT_RANGE_DAYS = 14;

type BrowseConversationsEntryPointComponent = EntryPointComponent<
	{
		page: QueryType;
	},
	{},
	{},
	{
		initialDateRange: DateRange;
	}
>;

export const browseConversationsEntryPoint: EntryPoint<
	BrowseConversationsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<BrowseConversationsEntryPointComponent>(
		/* webpackChunkName: "async-virtual-agent-browse-conversations" */ './VirtualAgentBrowseConversations.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const end = new Date();
		const start = new Date(end);
		start.setDate(start.getDate() - DEFAULT_RANGE_DAYS);

		return {
			extraProps: {
				initialDateRange: {
					start,
					end,
				},
			},
			queries: {
				page: {
					parameters: VirtualAgentBrowseConversationsQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
						startDate: start.toISOString(),
						endDate: end.toISOString(),
					},
				},
			},
		};
	},
});
